import FetchHelper from '../helpers/fetch_helper';
import FunctionalityAccessHelper from '../helpers/functionality_access_helper';

const CustomerHistoryDispatcher = {
  async getSetStore(url, key, self, version = '/v3') {
    const result = await FetchHelper.fetchJson(url, {
      version,
    })
      .then((data) => Promise.resolve(data?.results))
      .catch((e) => Promise.resolve([]));

    self.setStoreValWithCheck(key, result);
    return result;
  },

  async fetchFridHistory(customerId) {
    return CustomerHistoryDispatcher.getSetStore(
      `customers/${customerId}/financing-requests?includeDeleted=true`,
      'fridHistory',
      this
    );
  },

  async fetchCustomerHistory(customerId) {
    return CustomerHistoryDispatcher.getSetStore(`customers/${customerId}`, 'customerHistory', this);
  },

  async fetchCustomerServiceLog(customerId) {
    return CustomerHistoryDispatcher.getSetStore(
      `customers/${customerId}/financing-requests/service-log`,
      'customerServiceLog',
      this
    );
  },

  async fetchCreditHistory(customerId) {
    return CustomerHistoryDispatcher.getSetStore(`customers/${customerId}/creditchecks`, 'creditCheckHistory', this);
  },
  async fetchSnapshotHistory(customerId) {
    return CustomerHistoryDispatcher.getSetStore(
      `customers/${customerId}/proposals/snapshots`,
      'snapshotHistory',
      this
    );
  },

  async fetchDisbursements(customerId) {
    return CustomerHistoryDispatcher.getSetStore(`disbursements?customerId=${customerId}`, 'disbursementHistory', this);
  },

  async fetchDisbursementsForStepMenu({ customerId, userFunctionalityAcls }) {
    if (FunctionalityAccessHelper.hasRewindStep(userFunctionalityAcls)) {
      return await CustomerHistoryDispatcher.getSetStore(
        `disbursements?customerId=${customerId}`,
        'customerDisbursementInfo',
        this
      );
    } else {
      this.setStoreValWithCheck('customerDisbursementInfo', []);
      return [];
    }
  },

  async fetchNotificationAudits(customerId) {
    return CustomerHistoryDispatcher.getSetStore(
      `notification-audits/customerId/${customerId}`,
      'notificationHistory',
      this
    );
  },

  async fetchCustomerAuditTrail(customerId) {
    return CustomerHistoryDispatcher.getSetStore(`customers/${customerId}/audit-trail`, 'customerAuditTrail', this);
  },

  async fetchSponsorApiEvents(customerId) {
    return CustomerHistoryDispatcher.getSetStore(
      `customers/${customerId}/sponsor-api-events`,
      'sponsorApiEventHistory',
      this,
      '/qa'
    );
  },

  async fetchWebhookEvents(customerId) {
    return CustomerHistoryDispatcher.getSetStore(
      `customers/${customerId}/webhook-events`,
      'customerWebhookHistory',
      this
    );
  },
};

export default CustomerHistoryDispatcher;
